import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-test-card-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './test-card-loader.component.html',
  styleUrl: './test-card-loader.component.scss'
})
export class TestCardLoaderComponent {
  @Input() count: number = 1;
}
